import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  DialogTitle,
  SubmitButton,
} from '@fortem-monorepo/react-ui'
import { ClientPricing } from '@fortem-monorepo/web-sdk'

import { AddProductToClientsFormFields } from '@/components/forms/AddProductToClientsFormNew/AddProductToClientsFormFieldsNew'
import { AddProductToClientsForm } from '@/components/forms/AddProductToClientsFormNew/AddProductToClientsFormNew'

export interface AddProductToClientsModalProps extends DialogProps {
  product?: ClientPricing.V2.NewProduct
}

export const AddProductToClientsModal: React.FC<AddProductToClientsModalProps> = ({
  product,
  ...props
}) => {
  return (
    <Dialog {...props}>
      <DialogContent className={'min-w-fit!'}>
        <AddProductToClientsForm
          defaultValues={{ org_ids: [], instrument_id: product?.instrument_id }}
        >
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Adding {product?.isin} to Clients</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <AddProductToClientsFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </AddProductToClientsForm>
      </DialogContent>
    </Dialog>
  )
}
